import { ROLE_PERMISSION_DESCRIPTIONS } from '../constants';
import type { OAuthContext, ValidatedOAuthContext } from '../types';

/**
 * Validates OAuth context for required fields (non-error cases only).
 * Throws descriptive errors for missing or invalid required fields.
 * Returns a ValidatedOAuthContext with guaranteed non-optional required fields.
 */
export function validateSuccessContext(ctx: OAuthContext): asserts ctx is ValidatedOAuthContext {
  // Validate required fields
  if (!ctx.integration_name) {
    throw new Error('Missing integration_name in OAuth context');
  }

  // Validate organizations array exists and is non-empty
  if (!ctx?.organizations?.length) {
    throw new Error('No organizations available in OAuth context');
  }

  // Validate that all organizations have valid names
  for (const org of ctx.organizations) {
    if (!org?.name || org.name.trim().length === 0) {
      throw new Error('All organizations must have a valid name');
    }
  }

  // Validate role_id is present and configured
  if (!ctx.role_id) {
    throw new Error('Missing role_id in OAuth context');
  }

  const permissions = ROLE_PERMISSION_DESCRIPTIONS[ctx.role_id];
  if (!permissions) {
    throw new Error(`Unknown role_id: ${ctx.role_id}. Please add permission descriptions for this role.`);
  }
}
